export default __webpack_public_path__ + "static/media/twitter.f8b18194.svg";